"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./bingmaps.component"));
__export(require("./osm.component"));
__export(require("./source.component"));
__export(require("./vector.component"));
__export(require("./vectortile.component"));
__export(require("./xyz.component"));
__export(require("./tilewms.component"));
__export(require("./geojson.component"));
__export(require("./tilejson.component"));
__export(require("./tileutfgrid.component"));
__export(require("./tilewmts.component"));
__export(require("./imagewms.component"));
__export(require("./imagestatic.component"));
__export(require("./cluster.component"));
__export(require("./raster.component"));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-openlayers/dist/components/sources/index.js
// module id = 592
// module chunks = 3